import { render, staticRenderFns } from "./SwapMain.vue?vue&type=template&id=41da775a&scoped=true"
import script from "./SwapMain.vue?vue&type=script&lang=js"
export * from "./SwapMain.vue?vue&type=script&lang=js"
import style0 from "./SwapMain.vue?vue&type=style&index=0&id=41da775a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41da775a",
  null
  
)

export default component.exports